// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1b-H7","footer":"Form_footer__2cMAA"};